<template>
    <div class="course-belongs" v-if="showCourseBelongsTo">
        <span class="course-belongs__title" v-html="">{{ $t("CollectionsCourseBelongs.title") }}:</span>
        <ul v-if="courseBelongsToLearningPaths">
            <li class="course-belongs__list-item" v-for="(learningPath, index) in learningPaths" :key="index">
                <span class="icon-crown"></span>
                <router-link
                    role="button"
                    :to="getRouteToLearningPath(learningPath.slug)"
                    class="course-belongs__learning-path-link"
                >
                    {{ learningPath.title }}
                </router-link>
            </li>
        </ul>
        <ul v-if="courseBelongsToCollections">
            <li class="course-belongs__list-item --collection" v-for="(collection, index) in collections" :key="index">
                <span class="icon-stack"></span>
                <router-link
                    role="button"
                    :to="getRouteToCollection(collection.slug)"
                    class="course-belongs__collection-link"
                >
                    {{ collection.title }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        props: {
            collections: Array,
            learningPaths: Array
        },
        mixins: [ routeHelper ],
        computed: {
            showCourseBelongsTo () {
                return this.courseBelongsToCollections || this.courseBelongsToLearningPaths
            },
            courseBelongsToCollections () {
                return this.collections && this.collections.length > 0
            },
            courseBelongsToLearningPaths () {
                return this.learningPaths && this.learningPaths.length > 0
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-belongs {
        display: flex;
        font-family: Quicksand-Regular, sans-serif;
        flex-direction: column;
        background-color: $heavy_metal;
        position: relative;
        width: 300px;
        padding: 0 0 10px;

        [class*="desktop_xxxl"] & {
          width: 370px;
        }
        [class*="mobile"] & {
          width: 100%;
        }

        &__title {
            font-size: 1.6rem;
            padding: 20px 20px;
            color: $white;
            font-family: Quicksand-Bold, sans-serif;
        }

        &__list-item {
            font-family: Nunito-Bold;
            font-size: 1.4rem;
            margin: 0 20px 6px;
            padding: 10px;
            background: $eerie_black;
            display: flex;
            align-items: center;

            &:last-of-type {
                border: none;
            }
        }

        &__learning-path-link,
        .icon-crown {
            color: $porsche;
        }

        &__collection-link,
        .icon-stack {
            color: $fire_bush;
        }

        [class*="icon-"] {
            margin: 0 10px 2px 0;
        }

    }
</style>
